<template>
    <modal-dialog
        ref="modalDialog"
        :confirmBtnTxt="isDeactivate ? `Deactivate` : `Reactivate`"
        :isLoading="isLoading"
        @confirm-dialog="confirmUpdate()"
    >
        <template v-slot:title>
            {{ isDeactivate ? `Deactivate Staff` : `Reactivate Staff` }}
        </template>
        <template v-slot:body>
            <div v-if="isDeactivate">
                <template v-if="hasReassignedField">
                    <div class="pb-2">
                        <b>{{ name }}</b> {{ confirmationDialog }}
                    </div>

                    <div v-if="isTask" class="row pt-3">
                        <div class="col-md-4">
                            <label for="reassignTask">
                                <b>
                                    Existing Open Tasks:
                                </b>
                            </label>
                        </div>
                        <div class="col-md">
                            <b-select
                                id="reassignTask"
                                v-model="selectedStaff"
                                :options="staffList"
                            ></b-select>
                        </div>
                    </div>

                    <div v-if="hasActionItemAssigned" class="row pt-3">
                        <div class="col-md-4">
                            <label for="reassignActionTask">
                                <b>
                                    Tasks created by actions:
                                    <i
                                        class="fas fa-info-circle"
                                        v-b-popover.hover.bottom="
                                            'This will reassign all task actions to selected staff'
                                        "
                                    ></i>
                                </b>
                            </label>
                        </div>
                        <div class="col-md">
                            <b-select
                                id="reassignActionTask"
                                v-model="selectedStaffActionTask"
                                :options="staffList"
                            ></b-select>
                        </div>
                    </div>

                    <div v-if="isAppointment" class="row pt-3">
                        <div class="col-md-4">
                            <label for="reassignAppointment"
                                ><b>Appointments:</b>
                            </label>
                        </div>
                        <div class="col-md">
                            <b-select
                                id="reassignAppointment"
                                v-model="selectedProvider"
                                :options="appointmentProviderList"
                            ></b-select>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div>
                        Past appointments will no longer appear on the schedule,
                        but can be viewed in reports or the applicable client or
                        patient profile. Do you want to deactivate
                        <b>{{ name }}</b
                        >?
                    </div>
                </template>
            </div>
            <div v-else>
                Please confirm that you wish to reactivate <b>{{ name }}</b
                >?
            </div>
        </template>
    </modal-dialog>
</template>
<style>
.modal {
    opacity: 0;
    transition: opacity 0.15s linear;
}

.modal.show {
    opacity: 1;
}
</style>
<script>
import staffService from "@/services/staff";
import ModalDialog from "@/components/commons/modal-dialog";

export default {
    components: {
        ModalDialog
    },
    computed: {
        hasReassignedField() {
            return (
                this.isTask || this.isAppointment || this.hasActionItemAssigned
            );
        },
        confirmationDialog() {
            let pendingItems = [];
            let pendingItems2 = [];
            if (this.isTask) {
                pendingItems.push("outstanding tasks");
                pendingItems2.push("tasks");
            }
            if (this.hasActionItemAssigned) {
                pendingItems.push("assigned task actions");
                pendingItems2.push("tasks actions");
            }
            if (this.isAppointment) {
                pendingItems.push("outstanding appointments");
                pendingItems2.push("appointments");
            }
            const formatList = arr => {
                if (arr.length > 1) {
                    return (
                        arr.slice(0, -1).join(", ") +
                        " and " +
                        arr[arr.length - 1]
                    );
                }
                return arr[0] || "";
            };

            return `has ${formatList(
                pendingItems
            )}. To whom should these ${formatList(
                pendingItems2
            )} be reassigned?`;
        }
    },
    data() {
        return {
            isLoading: false,
            id: null,
            isDeactivate: null,
            staffList: [],
            appointmentProviderList: [],
            isTask: false,
            isAppointment: false,
            selectedStaff: null,
            selectedStaffActionTask: null,
            selectedProvider: null,
            name: null,
            display: "none",
            hasActionItemAssigned: false
        };
    },
    methods: {
        async open(id, name, isDeactivate) {
            this.clear();
            this.id = id;
            this.name = name;
            this.isDeactivate = isDeactivate;
            if (isDeactivate) {
                const res = await staffService.getDeactivateConfirmation(id);
                const { resource } = res.data.response;
                if (resource) {
                    /**
                     * VET-2446
                     * Check if the user is assigned in action item and action template task
                     */
                    this.hasActionItemAssigned =
                        resource.message.task_action == true;

                    if (resource.message.tasks || this.hasActionItemAssigned) {
                        this.staffList = await resource.staff_list
                            .map(data => {
                                return {
                                    value: data.id,
                                    text: data.display_name
                                };
                            })
                            .sort((a, b) => {
                                //sort name asc
                                const nameA = a.text.toLowerCase();
                                const nameB = b.text.toLowerCase();

                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            });

                        if (resource.message.tasks) {
                            this.selectedStaff = this.staffList[0].value;
                            this.isTask = true;
                        }

                        if (this.hasActionItemAssigned) {
                            this.selectedStaffActionTask = this.staffList[0].value;
                        }
                    }
                    if (resource.message.appointments) {
                        this.appointmentProviderList = await resource.appointment_provider_list
                            .map(data => {
                                return {
                                    value: data.id,
                                    text: data.name
                                };
                            })
                            .sort((a, b) => {
                                //sort name asc
                                const nameA = a.text.toLowerCase();
                                const nameB = b.text.toLowerCase();

                                if (nameA < nameB) {
                                    return -1;
                                }
                                if (nameA > nameB) {
                                    return 1;
                                }
                                return 0;
                            });
                        this.selectedProvider = this.appointmentProviderList[0].value;

                        this.isAppointment = true;
                    }
                }
            }
            this.$refs.modalDialog.open();
        },
        clear() {
            this.id = null;
            this.isDeactivate = null;
            this.staffList = [];
            this.appointmentProviderList = [];
            this.isTask = false;
            this.isAppointment = false;
            this.selectedProvider = null;
            this.selectedStaff = null;
            this.name = null;
            this.$refs.modalDialog.close();
        },
        async confirmUpdate() {
            this.isLoading = true;
            let params = {};
            const errorMessage = `Error: Cannot ${
                this.isDeactivate ? "Deactivate" : "Reactivate"
            } Staff`;

            try {
                let update = null;

                if (this.isDeactivate) {
                    if (this.isTask) {
                        params.reassign_staff_id = this.selectedStaff;
                    }

                    if (this.isAppointment) {
                        params.reassign_provider_id = this.selectedProvider;
                    }

                    if (this.hasActionItemAssigned) {
                        params.reassign_task_action_staff_id = this.selectedStaffActionTask;
                    }

                    update = await staffService.deactivate(this.id, params);
                } else {
                    update = await staffService.reactivate(this.id);
                }

                const { status, data } = update;
                if (update && status == 200) {
                    if (data?.response?.message?.description) {
                        this._message(data.response.message.description);
                    }
                } else {
                    throw new Error(errorMessage);
                }
                this.clear();
                this.$emit("update-complete");
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                this._message(errorMessage, "danger");
            } finally {
                this.isLoading = false;
            }
        }
    }
};
</script>
